import React, { useState } from "react";
import {
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
  Button,
  InputAdornment,
  IconButton,
  Breadcrumbs,
  Box,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const them = useTheme();
  const isMobile = them.breakpoints.down("sm");
  const [oldPassword, setOldPassword] = useState("");
  const [olspasswordError, setOldPasswordError] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formMode, setFormMode] = useState("initial"); // Assuming "initial", "add", and "edit" are the modes

  const handleOldPasswordChangeVisibility = (e) => {
    setShowOldPassword(!showOldPassword);
  };
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validateForm = () => {
    let isValid = true;
    if (!oldPassword) {
      setOldPasswordError(true);
      isValid = false;
    }
    if (!newPassword) {
      setNewPasswordError(true);
      isValid = false;
    }
    if (!confirmPassword) {
      setConfirmPasswordError(true);
      isValid = false;
    }
    return isValid;
  };
  const stopErrorHelperText = () => {
    setOldPasswordError(false);
    setNewPasswordError(false);
    setConfirmPasswordError(false);
  };

  const resetForm = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    stopErrorHelperText();
  };

  const handleAddNew = () => {
    setFormMode("add");
  };

  const handleCancel = () => {
    setFormMode("initial");
    resetForm();
  };

  const onSubmit = () => {
    if (validateForm()) {
      if (newPassword === confirmPassword) {
        toast.error("Passwords do not match");
      } else {
        toast.success("Submit new password");
        resetForm();
      }
    }
  };

  const onUpdate = () => {
    console.log("Update password");
  };

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12}>
          <Box sx={{ mt: 1, mb: 2 }}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                to="/dashboard/dashbordhome"
                style={{ textDecoration: "none", color: "primary" }}
              >
                Home
              </Link>
              <Typography color="textPrimary">Change Your Password</Typography>
            </Breadcrumbs>
          </Box>

          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Change Your Password (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Old Password (*)"
                  fullWidth
                  size="small"
                  type={showOldPassword ? "text" : "password"}
                  value={oldPassword}
                  error={olspasswordError}
                  helperText={
                    olspasswordError ? "Old Password is required" : ""
                  }
                  onChange={(e) => setOldPassword(e.target.value)}
                  disabled={formMode === "initial"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleOldPasswordChangeVisibility}>
                          {showOldPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="New Password (*)"
                  fullWidth
                  size="small"
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  error={newPasswordError}
                  helperText={
                    newPasswordError ? "New Password is required" : ""
                  }
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={formMode === "initial"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePasswordVisibility}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Confirm Password (*)"
                  fullWidth
                  size="small"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  error={confirmPasswordError}
                  helperText={
                    confirmPasswordError ? "Confirm Password is required" : ""
                  }
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={formMode === "initial"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleToggleConfirmPasswordVisibility}
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ChangePassword;
